export const DAY_IN_MILISECONDS = 24 * 60 * 60 * 1000;
export const CAROUSEL_SCROLL_POSITION_KEY_DESKTOP = 'carouselScrollPositionDesktop';
export const CAROUSEL_SCROLL_POSITION_KEY_MOBILE = 'carouselScrollPositionMobile';
export const SEARCH_PARAM_SELECTED_KEY = 'searchParamClicked';
